import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PROJECTS = [
  {
    id: 'biogas',
    tag: 'Clean Energy',
    status: 'Active',
    title: 'Village Biogas Initiative',
    desc: 'Turning agricultural waste into clean cooking gas and organic fertilizer across rural Maharashtra.',
    image: 'https://images.unsplash.com/photo-1518173946687-a4c8892bbd9f?w=900&q=80',
    link: '/projects/biogas',
  },
  {
    id: 'art',
    tag: 'Heritage',
    status: 'Coming 2026',
    title: 'Village Art & Culture',
    desc: 'Preserving rural art forms and creating livelihoods for artisans through modern markets.',
    image: 'https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=900&q=80',
    link: '/projects/art',
  },
];

export default function ProjectsSection() {
  return (
    <section id="projects" className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end"
        >
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-green-700">Beyond the marketplace</p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Other Atharva initiatives
            </h2>
          </div>
          <p className="max-w-md text-sm text-gray-600">
            The marketplace is our flagship. Around it, we run focused programs that compound rural impact.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {PROJECTS.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
            >
              <Link
                to={p.link}
                className="group block overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute left-3 top-3 inline-flex items-center gap-2 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-gray-800 backdrop-blur-sm">
                    <span className="h-1.5 w-1.5 rounded-full bg-green-500" />
                    {p.tag} · {p.status}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900">{p.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-gray-600">{p.desc}</p>
                  <p className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-green-700 group-hover:text-green-800">
                    Learn more
                    <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                    </svg>
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
